export const SESSION_STORAGE_KEYS = {
  MARKET_FLOATING: 'market-floating', // MMP 마켓 플로팅
  CROSS_SELL_OFFER_IDS: 'cross-sell-offer-ids', // cross-sell 상품 추천 퍼널
};
